import React, { Component } from 'react';
import "./GameViews/unlockedFeatureRoadmap.css";
import { Tooltip } from "@mui/material";
import { connect } from 'react-redux';
import UnlockedFeaturesCriteriaModal from './unlocked_features_criteria_modal';
import { calcMonthlyIncome } from '../../objects/CommonUse/calcMonthlyIncome';
import calculateJobSalary from '../../objects/AssetsExpenses/calculate_job_salary';
import determineCreditScore from './objectsEndOfTurn/determine_credit_score';
import determineNbrUnlockedLevels from './objectsEndOfTurn/determine_nbr_unlocked_levels';

// mapStateToProps: pick the Redux state your component needs
const mapStateToProps = (state) => ({
    gameData: state.gameData,
    creditCardInfo: state.creditCardInfo,
    timeWizardInfo: state.timeWizardInfo
});

class UnlockedFeaturesRoadmap extends Component {
    constructor(props) {
        super(props); 
        this.state={
            featuresCriteria: false,
        }
     
    }
    
    displayFeatureCriteria(featureName){
        this.openProcess = true;
        this.gameData = this.props.gameData;
        this.featureName = this.props.featureInfo.featureName;
        let feature = this.gameData.unlockedFeatures.find(elem => elem.featureName === this.featureName);
        if (!feature){
            this.featureLevel = 0;
            this.featureStatus = "none";
        }else{
            const maxLevelArr = determineNbrUnlockedLevels(this.featureName);
            const maxLevel = maxLevelArr[0].nbrLevels;
            if (feature.setup === "inactive" && +feature.level < +maxLevel){
                this.featureLevel = +feature.level + 1;
                this.featureStatus = "none";
            }else{
                this.featureLevel = feature.level;
                this.featureStatus = feature.setup;
            }
        }
        this.nbrGameMonths = +this.props.totalNbrGameMonths - +this.props.gameData.gameNbrMonths;
        this.currentCash = this.props.gameData.currentCash;
        let incomeObj = calcMonthlyIncome(this.gameData.assetTable,
            this.gameData.expenseTable, this.gameData.loanTable);
        this.monthlyIncome = incomeObj.income;
        this.annualSalary = 0;
        this.creditReport = determineCreditScore(this.props.creditCardInfo, 
            this.gameData.loanTable, this.gameData.currentGameDate,
            this.gameData.gameNbrMonths, this.props.timeWizardInfo );
        if (this.featureName === "creditCard"){
            this.annualSalary = calculateJobSalary(this.gameData.assetTable, 
                this.gameData.currentGameDate, false, "annual");
        }

        this.setState({featuresCriteria: true});
    }

    closeModal(){
        this.setState({featuresCriteria: false});
    }
       
    render() {
        const imgSrc = "./assets/UnlockedFeatures/" + this.props.featureInfo.imgSrc;
        const opacity = this.props.featureInfo.opacity;
        const progressBarOpacity = this.props.featureInfo.progressDashArr;
        if (this.props.featureInfo.displayName.length <= 15){
              this.cardTextClassValue = "card-body p-2"
        }else{
              this.cardTextClassValue = "card-body p-0"
        }
        let featureLevel = this.props.featureInfo.currentLevel;
        if (this.props.featureInfo.currentLevel === 0){
            featureLevel = '★';
        }
        const ProgressDashes = ({ count = 3, opacity = 1 }) => (
            <div className="unlock-progress-dashes">
                {Array.from({ length: count }).map((_, i) => (
                    <span key={i} className="unlock-dash-outline">
                        <span
                            className="unlock-dash"
                            style={{ opacity: Array.isArray(opacity) ? (opacity[i] ?? 1) : opacity }}
                        />
                    </span>
                ))}
            </div>
        );
        const tooltipBadgeText = "The level you are currently using.";
        const tooltipFeatureText = "This is an unlocked feature. " +
            "To learn more click the 'Unlocked Features' button to the right."
        const tooltipDashesText = "Number of levels for this feature and your progress toward earning the level."
   
    return (
        <div className="unlock-feature-wrapper">
        <div className="text-pointer unlock-feature-position" style={{opacity: opacity}}
            onClick={() => this.displayFeatureCriteria()}>

            <div className="card mr-5 unlock-rounded-corners unlock-link-card unlock-card-inner">
                 <Tooltip title={tooltipBadgeText} arrow >
                    {this.props.featureInfo.earnedMore ?
                        <div className="unlock-level-badge unlock-level-badge-pulse badge-nbr-font">
                            {featureLevel}
                        </div>
                    :
                        <div className="unlock-level-badge badge-nbr-font">
                            {featureLevel}
                        </div>
                    }
                </Tooltip>
 
                <Tooltip title={tooltipFeatureText} arrow >
                    <div>
                        <img className="unlock-card-img-top" src={imgSrc} alt="Card cap" />
                        <div className="card-body p-0 vertical-center">
                            <div className="primary-blue unlock-linkCard-text">
                                {this.props.featureInfo.displayName}
                            </div>
                        </div>
                    </div>
                </Tooltip>
                 <Tooltip title={tooltipDashesText} arrow >
                    <div className="mt-4">
                        <ProgressDashes count={this.props.featureInfo.nbrDashes} opacity={progressBarOpacity}/>
                    </div>
                </Tooltip>
            </div>
        </div>

            
        {this.state.featuresCriteria ?
            <UnlockedFeaturesCriteriaModal show={this.state.featuresCriteria}
                featureName={this.featureName}
                featureLevel={this.featureLevel}
                featureStatus={this.featureStatus}
                gameNbrMonths={this.nbrGameMonths}
                currentCash={this.currentCash}
                savings={this.savings}
                monthlyIncome={this.monthlyIncome}
                annualSalary={this.annualSalary}
                creditReportObj={this.creditReport}
                onClose={() => this.closeModal("featureCriteria")}
            />
        :
            null
        }

        </div>
    
    );
  }

}
 
export default connect(mapStateToProps)(UnlockedFeaturesRoadmap);